import React from 'react';
import { HomeIcon, RulerIcon, TagIcon, UsersIcon } from 'lucide-react';
const items = [{
  label: 'Family-owned since 2000',
  Icon: UsersIcon
}, {
  label: 'Free estimates',
  Icon: TagIcon
}, {
  label: 'Custom measurement & installation',
  Icon: RulerIcon
}, {
  label: 'Local showroom in Howell',
  Icon: HomeIcon
}];
export function TrustStrip() {
  return <section aria-label="Why customers choose Kosin’s Glass" className="border-b border-kosin-line bg-kosin-mist" data-id="element-236" data-mp="2f9o76s6qbohu">
      <ul className="mx-auto grid max-w-shell grid-cols-2 gap-x-4 gap-y-4 px-[18px] py-5 text-[13px] text-kosin-ink sm:gap-x-8 sm:px-6 sm:text-[15px] lg:grid-cols-4 lg:py-4" data-id="element-237" data-mp="25dkwuz1q4jjt">
        {items.map(({
        label,
        Icon
      }) => <li key={label} className="flex items-center gap-2.5" data-id="element-238" data-mp="1wdepzw0j6htm">
            <Icon className="h-[18px] w-[18px] shrink-0 text-kosin-red" aria-hidden="true" data-id="element-239" data-mp="3us982wykvvg9" />
            <span data-id="element-240" data-mp="3upwran4k3r4s">{label}</span>
          </li>)}
      </ul>
    </section>;
}